import vars from '../helpers';
import router from '../router';

const init = () => {
	const $gameStep = vars.$document.find('.js-game-step-container');
	const $checkButton = vars.$document.find('.js-check-button');
	const $checkText = vars.$document.find('.js-check-text');
	const $checkCircle = vars.$document.find('.js-check-circle');
	const $check = vars.$document.find('.js-check');
	const $true = vars.$document.find('.js-video-true');
	const $false = vars.$document.find('.js-video-false');
	const $answerSection = vars.$document.find('.js-game-answer');
	const $trueMobile = vars.$document.find('.js-boolean-true');
	const $falseMobile = vars.$document.find('.js-boolean-false');
	const $infoMobile = vars.$document.find('.js-boolean-info');

	const refreshSrc = ($obj) => {
		const src = `${$obj.find('img').attr('src')}${Math.random()}`;

		$obj.find('img').remove();

		let img = new Image();

		$(img).attr('src', src).attr('alt', '').appendTo($obj);
	};

	$checkButton.on('click', () => {
		const variantLeft = vars.$document.find('.js-slider[data-type="left"] .slick-active .js-slide').data('answer');
		const variantRight = vars.$document.find('.js-slider[data-type="right"] .slick-active .js-slide').data('answer');
		const textLeft = vars.$document.find('.js-slider[data-type="left"] .slick-active .js-step-text').text();
		const textRight = vars.$document.find('.js-slider[data-type="right"] .slick-active .js-step-text').text();

		let result = 'success';

		if (variantLeft === variantRight) {
			const $answerInner = $answerSection.find(`.js-answer-inner[data-answer="${variantLeft}"]`);

			vars.$html.trigger('check-click', [result, textLeft, textRight]);

			if (!vars.isMobile()) {
				let tl = gsap.timeline();

				vars.gsapCleaner([$check, $checkText, $checkCircle, $true, $false, $answerSection]);

				tl
					.to($checkText, {
						onStart() {
							refreshSrc($true);
						},
						onComplete() {
							$checkText.addClass('is-hidden');
						},
						opacity: 0,
						duration: 1,
						clearProps: 'all',
					}, 0)
					// .to($checkCircle, {
					// 	borderColor: 'transparent',
					// 	duration: 0.5,
					// }, 0)
					.from($true, {
						onStart() {
							// refreshSrc($true);
							$true.removeClass('is-hidden');
							// vars.$html.trigger('gif-video-play', 'true');
						},
						opacity: 0,
						duration: 0.5,
					}, 0.5)
					.from($answerSection, {
						onStart() {
							$answerSection.removeClass('is-hidden');
							$answerInner.removeClass('is-hidden');
						},
						onComplete() {
							vars.$html.trigger('show-answer-window', $answerInner.find('.js-answer-inner-text').text());
							vars.$html.trigger('slider-remove-slide');
						},
						autoAlpha: 0,
						duration: 0.5,
						clearProps: 'all',
					}, 2)
					.to($true, {
						onComplete() {
							$true.addClass('is-hidden');
							// refreshSrc($true);
							// vars.$html.trigger('slider-remove-slide');
						},
						opacity: 0,
						duration: 0.5,
						clearProps: 'all',
					}, 2.5)
					.from($checkText, {
						onStart() {
							$checkText.removeClass('is-hidden');
						},
						opacity: 0,
						duration: 0.5,
						clearProps: 'all',
					}, 2.5)
					// .from($checkCircle, {
					// 	borderColor: 'transparent',
					// 	duration: 0.5,
					// }, 2.5)
				;
			} else {
				let tl = gsap.timeline();

				vars.gsapCleaner([vars.$siteContainer, $answerSection, $trueMobile, $answerInner, $check]);

				tl
					.to(vars.$siteContainer, {
						keyframes: [
							{
								onComplete() {
									$gameStep.addClass('is-hidden');
									$check.addClass('is-hidden');

									$answerSection.removeClass('is-hidden');
									$trueMobile.removeClass('is-hidden');
									$answerInner.removeClass('is-hidden');

									// vars.$html.trigger('slider-remove-slide');
									$answerSection.attr('data-answer', 'true');
									vars.$html.trigger('show-answer-window', $answerInner.find('.js-answer-inner-text').text());

									window.scrollTo(0, 0);
								},
								autoAlpha: 0,
								duration: 0.5,
							},
							{
								onStart() {
									refreshSrc($trueMobile);
								},
								onComplete() {

								},
								autoAlpha: 1,
								duration: 0.5,
							},
						],
					})
				;
			}
		}

		if (variantLeft !== variantRight) {
			result = 'mistake';

			vars.$html.trigger('check-click', [result, textLeft, textRight]);

			if (!vars.isMobile()) {
				let tl = gsap.timeline();

				vars.gsapCleaner([$check, $true, $false]);

				tl
					.to($checkText, {
						onStart() {
							refreshSrc($false);
						},
						onComplete() {
							$checkText.addClass('is-hidden');
						},
						opacity: 0,
						duration: 0.5,
						clearProps: 'all',
					}, 0)
					.from($false, {
						onStart() {
							$false.removeClass('is-hidden');
							// vars.$html.trigger('gif-video-play', 'false');
						},
						opacity: 0,
						duration: 0.5,
					}, 0.5)
					.to($false, {
						onComplete() {
							$false.addClass('is-hidden');
							refreshSrc($false);
						},
						opacity: 0,
						duration: 0.5,
						clearProps: 'all',
					}, 2)
					.to($checkText, {
						onStart() {
							$checkText.removeClass('is-hidden');
						},
						opacity: 1,
						duration: 0.5,
						clearProps: 'all',
					}, 2)
				;
			} else {
				let tl = gsap.timeline();

				vars.gsapCleaner([vars.$siteContainer, $falseMobile, $infoMobile, $check]);

				tl
					.to(vars.$siteContainer, {
						keyframes: [
							{
								onComplete() {
									$gameStep.addClass('is-hidden');
									$check.addClass('is-hidden');

									$answerSection.removeClass('is-hidden');
									$falseMobile.removeClass('is-hidden');
									$infoMobile.removeClass('is-hidden');

									$answerSection.attr('data-answer', 'false');

									window.scrollTo(0, 0);
								},
								autoAlpha: 0,
								duration: 0.5,
							},
							{
								onStart() {
									refreshSrc($falseMobile);
								},
								onComplete() {

								},
								autoAlpha: 1,
								duration: 0.5,
							},
						],
					})
				;
			}
		}
	});

	const $next = vars.$document.find('.js-next');

	$next.on('click', () => {
		let key = !vars.isMobile() ? 0 : 1;

		if (+$('.js-slider[data-type="left"').find('.slick-slide').length === key) {
			router.navigate('/game/result');

			vars.$html.trigger('show-final-screen');
		} else {
			const $answerInner = $answerSection.find('.js-answer-inner:not(.is-hidden)');

			if (!vars.isMobile()) {
				let tl = gsap.timeline();

				tl
					.to($answerSection, {
						onComplete() {
							$answerSection.addClass('is-hidden');
							$answerInner.addClass('is-hidden');
						},
						duration: 0.5,
						autoAlpha: 0,
						clearProps: 'all',
					})
				;
			} else {
				let tl = gsap.timeline();

				tl
					.to(vars.$siteContainer, {
						keyframes: [
							{
								onComplete() {
									$gameStep.removeClass('is-hidden');
									$check.removeClass('is-hidden');

									$answerSection.addClass('is-hidden');
									$answerInner.addClass('is-hidden');

									!$trueMobile.hasClass('is-hidden') ? $trueMobile.addClass('is-hidden') : false; // eslint-disable-line

									$answerSection.removeAttr('data-answer');
									vars.$html.trigger('slider-remove-slide');

									window.scrollTo(0, 0);
								},
								autoAlpha: 0,
								duration: 0.5,
							},
							{
								onStart() {
									// refreshSrc($trueMobile);
								},
								onComplete() {
									refreshSrc($trueMobile);
								},
								autoAlpha: 1,
								duration: 0.5,
							},
						],
					})
				;
			}
		}
	});

	const $close = vars.$document.find('.js-answer-close');

	$close.on('click', () => {
		let tl = gsap.timeline();

		vars.gsapCleaner([vars.$siteContainer, $falseMobile, $infoMobile, $check]);

		tl
			.to(vars.$siteContainer, {
				keyframes: [
					{
						onComplete() {
							$gameStep.removeClass('is-hidden');
							$check.removeClass('is-hidden');

							$answerSection.addClass('is-hidden');
							$falseMobile.addClass('is-hidden');
							$infoMobile.addClass('is-hidden');

							$answerSection.removeAttr('data-answer');

							window.scrollTo(0, 0);
						},
						autoAlpha: 0,
						duration: 0.5,
					},
					{
						onStart() {
							// refreshSrc($falseMobile);
						},
						onComplete() {
							refreshSrc($falseMobile);
						},
						autoAlpha: 1,
						duration: 0.5,
					},
				],
			})
		;
	});

	vars.$html.on('check-destroy', () => {
		vars.$document.find('.js-game-answer:not(.is-hidden)').addClass('is-hidden');
		vars.$document.find('.js-answer-inner:not(.is-hidden)').addClass('is-hidden');
		refreshSrc($true);
		refreshSrc($false);
		// vars.gsapCleaner([$check, $true, $false, $answerSection]);
	});
};

const destroy = () => {
	vars.$html.trigger('check-destroy');
};

export default {
	init,
	destroy,
};
